// @material-ui/icons
import PeopleIcon from '@material-ui/icons/People'
import HeimratTenantsTab from '../components/tenant/heimrat/HeimratTenantsTab'

export const schlichtungDepartmentRoutes = [
  {
    path: '/dashboard/tenants',
    name: 'Bewohner',
    icon: PeopleIcon,
    component: HeimratTenantsTab,
  },
]
